import { Form, Input, Row, Col, DatePicker } from 'antd';
import PropTypes from 'prop-types';
import * as fieldMsgs from 'constants/formFieldsMessages';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import moment from 'moment';

const AcuerdoCOF = ({ form, idProcesoGeneral }) => {
  const dateFormat = 'YYYYMMDD';
  const [fechaFinOper, setFechaFinOper] = useState(null);

  useEffect(() => {
    setFechaFinOper(moment().format('YYYYMMDD HH:mm:ss'));
  }, []);

  useEffect(() => {
    if (idProcesoGeneral) {
      // setFechaIniciOper(
      //   configuracionSistema.find((config) => config.idProcesoElectoral === idProcesoGeneral)
      //     ?.fechaInicio || null
      // );
      // setFechaFinOper(
      //   configuracionSistema.find((config) => config.idProcesoElectoral === idProcesoGeneral)
      //     ?.fechaFin || null
      // );
      // setFechaFinOper(moment().format('YYYYMMDD HH:mm:ss'));
    }
  }, [idProcesoGeneral]);

  return (
    <div>
      <Form form={form} layout="vertical">
        <Row gutter={24}>
          <Col xs={24}>
            <Form.Item name="acuerdo_cof" label="Acuerdo COF">
              <Input.TextArea placeholder="Escribe" rows={4} showCount maxLength={200} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={6}>
            <Form.Item
              name="fecha_acuerdo_aprobado"
              label="Fecha de Acuerdo de la COF:"
              rules={[{ required: true, message: fieldMsgs.ERR_DATE_FIELD_REQUIRED }]}>
              <DatePicker
                placeholder="Selecciona"
                style={{ width: '100%' }}
                maxDate={dayjs(fechaFinOper, dateFormat)}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

AcuerdoCOF.propTypes = {
  form: PropTypes.shape({}).isRequired,
  idProcesoGeneral: PropTypes.number.isRequired
};

export default AcuerdoCOF;
